const ArrowLeftIcon = ({ className }) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2285 4.99986H0.728516M0.728516 4.99986L5.22852 0.5M0.728516 4.99986L5.22852 8.99986"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default ArrowLeftIcon;

